import { render, staticRenderFns } from "./moreHoriz.vue?vue&type=template&id=277511a4&"
import script from "./moreHoriz.vue?vue&type=script&lang=js&"
export * from "./moreHoriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports